import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import NoRoute from "../universal/noroute";
import SignIn from "../auth/signin";
import * as routes from "../../constants/app_routes";
import Dashboard from "../dashboard";
import {requireAuth} from "../hoc/require_auth";
import Header from "../universal/header"
import Properties from "../properties";
import Admin from "../user/admin";
import Agent from "../user/agent";
import Clerk from "../user/clerk";
import AdminProfile from "../user/admin/profile";
import Company from "../company";
import Inspection from "../inspection";
import CreateProperty from "../properties/create_property";
import QuickSearch from "../properties/quicksearch";
import CompanyPriceList from '../company/price_list';
import ClerkPriceList from '../user/clerk/clerk_price_list';
import CreateInspection from '../inspection/create_inspection';
import ClerkProfile from '../user/clerk/profile';
import AgentProfile from '../user/agent/profile';
import Report from '../report';
import UpdateInspection from "../inspection/update_inspection";
import CreateReport from "../report/create_report";
import Footer from "../universal/footer";
import ReportTemplateList from "../report/templates/";
import ReportModules from "../report/modules/";
import CreateModule from "../report/modules/create_module";
import Invoice from "../accounts/invoice";
import ViewInvoice from "../accounts/invoice/view_invoice";
import ViewEstimate from "../accounts/invoice/view_estimate";
import Remittance from "../accounts/remittance";
import Expense from "../accounts/expense";
import ViewExpense from "../accounts/expense/view_expense";
import ViewRemittance from "../accounts/remittance/view_remittance";
import ViewRemittanceEstimate from "../accounts/remittance/view_estimate";
import ResetPassword from "../auth/reset_password";
import ChangePassword from "../auth/change_password";
import ViewExpenseEstimate from "../accounts/expense/view_expense_estimate";
import CreateOrUpdateTemplate from "../report/templates/create_or_update_template";
import CustomReportUpload from "../report/custom_report_upload";
import ChangeUserEmail from "../auth/change_email";
import UserAccountSettings from "../user/user_account_settings";
import ReportViewer from "../report/report_viewer"
import PVReportViewer from "../property_visits/pv_report_viewer"
import CustomerService from "../inspection/customer_service_schedule"
import ScheduleOfConditionsGenerator from "../report/soc_generator/schedule_of_conditions_generator"
import VisualElecGenerator from '../report/visual_elec_generator/visual_elec_generator';
import PropertyVisitSchedule from "../property_visits/property_visit_schedule"
import AddPropertyVisit from "../property_visits/add_property_visit"
import PropertyVisitReportBuilder from '../property_visits/property_visit_report_builder';
import ClerkExpensesGenerator from '../report/expenses_generator/expenses_generator';
import ClerkDistribution from '../report/clerk_distribution/clerk_distribution';

class BrowserAppRoutes extends Component {

    render() {
        const ADMIN = requireAuth(['admin']);
        const CLERK = requireAuth(['clerk', 'admin']);
        const AGENT = requireAuth(['agent', 'admin']);
        const ALL_USER = requireAuth(['agent', 'admin', 'clerk']);
        return (
            <Router>
                <div>
                    <Header/>
                    <Switch>
                        <Route exact path={routes.HOME} component={ALL_USER(Dashboard)}/>
                        <Route exact path={routes.SIGN_IN} component={SignIn}/>
                        <Route path={routes.FORGOT_PASSWORD} component={ResetPassword} />
                        <Route path={routes.CHANGE_PASSWORD} component={ALL_USER(ChangePassword)} />
                        <Route path={routes.CHANGE_EMAIL} component={ALL_USER(ChangeUserEmail)} />
                        <Route path={routes.SETTINGS} component={ALL_USER(UserAccountSettings)} />
                        <Route exact path={routes.DASHBOARD} component={ALL_USER(Dashboard)}/>
                        <Route exact path={routes.PROPERTIES} component={ALL_USER(Properties)}/>
                        <Route exact path={routes.ADMIN} component={ADMIN(Admin)}/>
                        <Route exact path={routes.AGENT} component={AGENT(Agent)}/>
                        <Route exact path={routes.CLERK} component={CLERK(Clerk)}/>
                        <Route exact path={routes.INSPECTION} component={ALL_USER(Inspection)}/>
                        <Route exact path={routes.ADMIN_PROFILE} component={ADMIN(AdminProfile)}/>
                        <Route exact path={routes.CLERK_PROFILE} component={CLERK(ClerkProfile)}/>
                        <Route exact path={routes.AGENT_PROFILE} component={AGENT(AgentProfile)}/>
                        <Route exact path={routes.COMPANY} component={CLERK(Company)}/>
                        <Route exact path={`${routes.PROPERTIES}/create`} component={ALL_USER(CreateProperty)}/>
                        <Route exact path={`${routes.PROPERTIES}/quicksearch`} component={ADMIN(QuickSearch)}/>
                        <Route exact path={`${routes.INSPECTION}/create`} component={ALL_USER(CreateInspection)}/>
                        <Route exact path={`${routes.COMPANY_PRICE_LIST}/:companyId`} component={ADMIN(CompanyPriceList)}/>
                        <Route exact path={routes.CLERK_PRICE_LIST} component={ADMIN(ClerkPriceList)}/>
                        <Route exact path={routes.REPORT} component={CLERK(Report)}/>
                        {/* <Route exact path={`${routes.INSPECTION}/update/:inspectionId`} component={AGENT(UpdateInspection)}/> */}
                        <Route exact path={`${routes.REPORT}/create/:reportId`} component={CLERK(CreateReport)}/>
                        <Route exact path={`${routes.REPORT}/template/list`} component={ADMIN(ReportTemplateList)}/>
                        <Route exact path={`${routes.REPORT_MODULE}`} component={ADMIN(ReportModules)}/>
                        <Route exact path={`${routes.REPORT_MODULE}/create`} component={ADMIN(CreateModule)}/>
                        <Route exact path={`${routes.INVOICE}`} component={AGENT(Invoice)}/>
                        <Route exact path={`${routes.INVOICE}/view/:invoiceId`} component={AGENT(ViewInvoice)}/>
                        <Route exact path={`${routes.INVOICE}/estimate/view/:estimateId`}
                               component={AGENT(ViewEstimate)}/>
                        <Route exact path={`${routes.REMITTANCE}`} component={CLERK(Remittance)}/>
                        <Route exact path={`${routes.REMITTANCE}/view/:remittanceId`} component={CLERK(ViewRemittance)}/>
                        <Route exact path={`${routes.REMITTANCE}/estimate/view/:estimateId`}
                               component={CLERK(ViewRemittanceEstimate)}/>
                        <Route exact path={`${routes.EXPENSE}`} component={CLERK(Expense)}/>
                        <Route exact path={`${routes.EXPENSE}/view/:expenseId`} component={CLERK(ViewExpense)}/>
                        <Route exact path={`${routes.EXPENSE}/pipeline/view/:pipelineExpenseId`} component={CLERK(ViewExpenseEstimate)}/>
                        <Route exact path={`${routes.REPORT}/template/:action/:templateId`} component={ADMIN(CreateOrUpdateTemplate)} />
                        <Route exact path={`${routes.REPORT}/template/:action`} component={ADMIN(CreateOrUpdateTemplate)} />
                        <Route exact path={`${routes.CUSTOM_REPORT}/create/:customReportId`} component={ALL_USER(CustomReportUpload)} />
                        <Route exact path={`${routes.REPORT_VIEWER}/:inspectionId/:token`} component={ReportViewer} />
                        <Route exact path={`${routes.PV_REPORT_VIEWER}/:pvId/:token`} component={PVReportViewer} />
                        <Route exact path={routes.CUSTOMER_SERVICE} component={ALL_USER(CustomerService)} />
                        <Route exact path={`${routes.SCHEDULE_OF_CONDITIONS}`} component={CLERK(ScheduleOfConditionsGenerator)} />
                        <Route exact path={`${routes.VISUAL_ELEC}`} component={CLERK(VisualElecGenerator)} />
                        <Route exact path={`${routes.EXPENSES_GENERATOR}`} component={CLERK(ClerkExpensesGenerator)} />
                        <Route exact path={`${routes.PRICE_LISTS}`} component={ADMIN(CompanyPriceList)} />
                        <Route exact path={`${routes.CLERK_DISTRIBUTION}`} component={ADMIN(ClerkDistribution)} />
                        <Route exact path={`${routes.PROPERTY_VISIT}`} component={ALL_USER(PropertyVisitSchedule)} />
                        <Route exact path={`${routes.PROPERTY_VISIT}/create`} component={CLERK(AddPropertyVisit)} />
                        <Route exact path={`${routes.PROPERTY_VISIT}/report/:visitId`} component={CLERK(PropertyVisitReportBuilder)} />
                        <Route path="*" component={NoRoute}/>
                    </Switch>
                    <Footer/>
                </div>
            </Router>
        );
    }
}

export default BrowserAppRoutes;


// WEBPACK FOOTER //
// ./src/views/router/index.js